import { createContext } from 'react';
export const MainSurfaceContext = createContext(null);
MainSurfaceContext.displayName = 'AppLayoutV2MainSurfaceContext';
//# sourceMappingURL=AppLayoutV2MainSurfaceContext.js.map